import React from "react";
import { useHistory, useParams } from "react-router-dom";

import ContainerLandpage from "containers/Landpage";
import { getTreatmentBySlug } from "screens/LandpageAesthetics/treatments-data";
import {
  PageRoot,
  SectionContainer,
  HeroSection,
  HeroEyebrow,
  HeroTitle,
  HeroText,
  HeroActions,
  PrimaryButton,
  SecondaryButton,
  InfoSection,
  InfoCard,
  InfoTitle,
  InfoText,
  HighlightList,
  HighlightItem,
  AlbumSection,
  AlbumHeader,
  AlbumEyebrow,
  AlbumTitle,
  AlbumText,
  AlbumGrid,
  AlbumCard,
  AlbumImage,
  AlbumCaption,
  EmptyState,
  EmptyCard,
  EmptyTitle,
  EmptyText,
} from "./styled";

export default function LandpageAestheticsTreatment() {
  const history = useHistory();
  const { slug } = useParams();
  const treatment = getTreatmentBySlug(slug);

  if (!treatment) {
    return (
      <ContainerLandpage variant="aesthetics">
        <PageRoot>
          <EmptyState>
            <SectionContainer>
              <EmptyCard>
                <EmptyTitle>Tratamento nao encontrado</EmptyTitle>
                <EmptyText>
                  Este tratamento nao foi localizado no catalogo atual. Volte para a pagina de
                  estetica e selecione um item disponivel.
                </EmptyText>
                <HeroActions>
                  <PrimaryButton type="button" onClick={() => history.push("/estetica")}>
                    Voltar para estetica
                  </PrimaryButton>
                </HeroActions>
              </EmptyCard>
            </SectionContainer>
          </EmptyState>
        </PageRoot>
      </ContainerLandpage>
    );
  }

  const openWhatsApp = () => {
    const message = encodeURIComponent(
      `Ola, quero agendar uma avaliacao para ${treatment.name}.`
    );
    window.open(`https://wa.me/61998333005?text=${message}`, "_blank");
  };

  return (
    <ContainerLandpage variant="aesthetics">
      <PageRoot>
        <HeroSection id="banner">
          <SectionContainer>
            <HeroEyebrow>{treatment.category}</HeroEyebrow>
            <HeroTitle>{treatment.name}</HeroTitle>
            <HeroText>{treatment.details}</HeroText>

            <HeroActions>
              <PrimaryButton type="button" onClick={openWhatsApp}>
                Agendar avaliacao
              </PrimaryButton>
              <SecondaryButton type="button" onClick={() => history.push("/estetica")}>
                Voltar ao catalogo
              </SecondaryButton>
            </HeroActions>
          </SectionContainer>
        </HeroSection>

        <InfoSection>
          <SectionContainer>
            <InfoCard>
              <InfoTitle>Sobre o tratamento</InfoTitle>
              <InfoText>{treatment.details}</InfoText>
              <HighlightList>
                {treatment.highlights.map((highlight) => (
                  <HighlightItem key={highlight}>{highlight}</HighlightItem>
                ))}
              </HighlightList>
            </InfoCard>
          </SectionContainer>
        </InfoSection>

        <AlbumSection id="album">
          <SectionContainer>
            <AlbumHeader>
              <AlbumEyebrow>Album</AlbumEyebrow>
              <AlbumTitle>Resultados e registros do tratamento</AlbumTitle>
              <AlbumText>
                Galeria com imagens de apoio para apresentar a proposta do protocolo e a
                evolucao visual de casos atendidos.
              </AlbumText>
            </AlbumHeader>

            <AlbumGrid>
              {treatment.album.map((item, index) => (
                <AlbumCard key={`${treatment.slug}-${index}`}>
                  <AlbumImage src={item.src} alt={`${treatment.name} ${item.label}`} />
                  <AlbumCaption>{item.label}</AlbumCaption>
                </AlbumCard>
              ))}
            </AlbumGrid>
          </SectionContainer>
        </AlbumSection>
      </PageRoot>
    </ContainerLandpage>
  );
}
